const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.1634 16.929C8.15953 18.2863 8.83589 18.7953 10.1835 18.8591M8.1634 16.929L11.586 13.4807M8.1634 16.929C7.6656 16.9291 5.7614 16.623 6.15079 14.538M10.1835 18.8591C10.277 20.5709 11.1228 21.1237 12.5 21L21.4277 11.8615C22.5593 10.2998 22 9.00019 21 8.00012L15.5 3.00003C15.5 3.00003 14.241 2.75304 13.5 3.00003C12.4521 3.34933 11.4731 4.76752 11.4731 4.76752M10.1835 18.8591L13.6448 15.5651M11.4731 4.76752C11.4731 4.76752 10.5657 3.29066 9.50001 3.00003C8.93486 2.8459 7.29128 3.0385 6.87707 3.45272L3.36597 7.00253C2.67586 7.81123 2.35238 8.59837 3.95899 9.95699M11.4731 4.76752L14.0163 7.30897C15.6693 8.72199 13.6297 10.8215 12.1234 9.5418L9.52741 6.99717L4.00001 12.5C3.13238 13.6351 5.0367 15.1405 6.15614 14.51C6.15431 14.5194 6.15253 14.5287 6.15079 14.538M6.15079 14.538L9.38577 11.3447",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.62db99aad57ee2bd86a38d39df794789.svg";
export { ForwardRef as ReactComponent };